import { render, staticRenderFns } from "./AppStartupManage.vue?vue&type=template&id=229e9f9e&scoped=true"
import script from "./AppStartupManage.vue?vue&type=script&lang=js"
export * from "./AppStartupManage.vue?vue&type=script&lang=js"
import style0 from "./AppStartupManage.vue?vue&type=style&index=0&id=229e9f9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e9f9e",
  null
  
)

export default component.exports